<template>

    <div v-click-outside="hideMenu" class="traits-selector">
        <v-dropdown-toggle :label="label" @click.native="toggleMenu" />
        <transition name="dropdown">
            <div v-show="show" class="traits-menu" :class="{ 'menu-right': menuRight }">
                <template v-if="isDraggable">
                    <draggable v-model="traits" group="traits" handle=".handle" @start="drag=true" @end="drag=false" @update="sortTraits">
                        <div class="traits-item" v-for="trait in traits" :key="trait.id">
                            <v-handle class="mr-5" :size="24" />
                            <v-checkbox :model="trait.visibility[type]" @input="updateTrait(trait, $event)" />
                            <span class="ml-6">{{ trait.name }}</span>
                        </div>
                    </draggable>
                </template>
                <template v-else>
                    <div class="traits-item" v-for="trait in traits" :key="trait.id">
                        <v-checkbox :model="trait.visibility[type]" @input="updateTrait(trait, $event)" />
                        <span class="ml-6">{{ trait.name }}</span>
                    </div>
                </template>
            </div>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    .traits-selector {
        position: relative;
        z-index: 100;
        .traits-menu {
            @include shad(2);
            background: #fff;
            border: 1px solid $color-rule;
            border-radius: 5px;
            left: 0;
            margin-top: 5px;
            max-height: 300px;
            overflow: auto;
            padding: 10px 0;
            position: absolute;
            right: auto;
            width: 300px;
            z-index: 1;
            &.menu-right {
                left: auto;
                right: 0;
            }
        }
        .traits-item {
            @include font-medium(12px);
            align-items: center;
            box-sizing: border-box;
            color: $color-text;
            display: flex;
            height: 26px;
            overflow: hidden;
            padding: 0 15px;
            text-overflow: ellipsis;
            transition: all .3s;
            user-select: none;
            > * {
                flex-shrink: 0;
            }
            span {
                flex-shrink: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            &:hover {
                background-color: $color-bg;
            }
        }
    }

</style>

<script>

import ClickOutside from 'vue-click-outside';
import draggable from 'vuedraggable'
import ProjectApi from '@api/ProjectApi';
import TraitApi from '@api/TraitApi';

export default {

    directives: {
        ClickOutside,
    },

    components: {
        draggable,
    },

    props: {
        label: {
            type: String,
            default: 'Traits',
        },
        type: {
            type: String,
            default: 'list',
        },
        isDraggable: {
            type: Boolean,
            default: true,
        },
        menuRight: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            show: false,
            traits: [],
        }
    },

    mounted() {
        this.traits = this.project.traits;
    },

    methods: {

        sortTraits() {
            // Sort
            this.traits.forEach((trait, index) => {
                trait.sort = index + 1;
            });
            // Submit
            let params = { ids: this.traits.map(trait => { return trait.id }) }
            ProjectApi.sortTraits(this.project.id, params);
        },

        updateTrait(trait, val) {
            trait.visibility[this.type] = val;
            let params = {
                name: trait.name,
                type: trait.type,
                visibility: trait.visibility,
            }
            TraitApi.updateTrait(trait.id, params);
        },

        toggleMenu() {
            this.show = !this.show;
        },

        hideMenu() {
            this.show = false;
        },

    }

}

</script>
